export var OWA_ROOT_PREFIX = '/owa/';
//# sourceMappingURL=constants.js.map